import * as types from '../constants/terminalsConstants';

const initialState = {list:[]};

export default function terminals(state = initialState, action) {
  switch(action.type) {
  case types.GET_TERMINAL_SUCCESS:
    return Object.assign({}, state, {list: action.response});
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./app/terminals/reducers/terminals.js